// 📌 Navbar Component (Navbar.jsx)

import React from "react";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    console.log("🚪 Logout button clicked");

    // Check if token exists before removing
    const token = localStorage.getItem("employeeToken");
    console.log("🔑 GURU employeeToken in localStorage:", token);

    if (token) {
      console.log("🔑 Found employeeToken in localStorage:", token);
      localStorage.removeItem("employeeToken");
      console.log("🗑️ employeeToken removed from localStorage");
    } else {
      console.log("⚠️ No employeeToken found in localStorage");
    }

    console.log("➡️ Redirecting to /employee-login page...");
    navigate("/employee-login");

    // Check if navigate works
    console.log("✅ Logout process complete");
  };

  return (
    <nav className="bg-white shadow p-4 flex justify-between items-center">
      <h2 className="text-lg font-semibold">Admin Dashboard</h2>
      <button
        onClick={handleLogout}
        className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition"
      >
        Logout
      </button>
    </nav>
  );
};

export default Navbar;
